import { useEffect } from 'react';
import {
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';
import { toast } from '@/shared/hooks/use-toast';
import {
  type Collection,
} from '../types';
import { collectionApi } from '../api';
import { collectionKeys } from './collection.keys';

// Query de detalhe
export function useCollection(
  id?: string,
  options?: Omit<UseQueryOptions<Collection, Error>, 'queryKey' | 'queryFn'>
) {
  const queryKey = id ? collectionKeys.detail(id) : [...collectionKeys.details(), ''];
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      if (!id) throw new Error('ID da coleção não informado');
      return collectionApi.get(id, signal);
    },
    enabled: Boolean(id),
    ...(options as Omit<UseQueryOptions<Collection, Error>, 'queryKey' | 'queryFn'>),
  });

  useEffect(() => {
    if (!query.error) return;
    toast({
      title: 'Erro ao carregar coleção',
      description: query.error.message,
      variant: 'destructive',
    });
  }, [query.error]);

  return {
    collection: query.data ?? null,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
    queryResult: query,
  };
}
